import ICommand from '../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../FrontApplet/FrontApplet';
import {
	ManagementNativeCommandsMdcRequests,
	ManagementNativeCommandsMdcSendOneRequest,
	ManagementNativeCommandsMdcSendOneResult,
} from './nativeMdcCommands';

export function handleManagementNativeCommandsMdcRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ManagementNativeCommandsMdcRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ManagementNativeCommandsMdcRequests>) => {
		switch (commandEvent.command.type) {
			case ManagementNativeCommandsMdcSendOneRequest:
				await dispatch<ManagementNativeCommandsMdcSendOneResult>({
					type: ManagementNativeCommandsMdcSendOneResult,
					result: await frontApplet.native.mdc.sendOne(
						commandEvent.command.ipAddress,
						commandEvent.command.codes,
						commandEvent.command.data,
					),
				});
				break;
			default:
		}
	});
}
